import React, {useEffect, useState} from 'react';
import {observer} from 'mobx-react-lite';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faGear, faDownload, faLink, faArrowLeft, faRotate} from '@fortawesome/pro-regular-svg-icons';
import {faCheck} from '@fortawesome/pro-solid-svg-icons';
import {Button, Tooltip, Menu, Dropdown} from 'antd';
import {countryFlag} from '@/utils/countries';
import {Globe} from 'react-feather';
import {getSingleUrlParam, isBulkReportPublicPage, removeSpaces} from '@/utils/url';
import {useStore} from '@/store/root-store';
import {useRouter} from 'next/router';
import styled from 'styled-components';
import moment from 'moment';
import {SkeletonHorizontalLoaderGray} from '@/components/common-components';
import {RingLoaderV2} from '@/components/common-components/components/skeleton/ring-loader-v2';
import {NextImg} from '@/utils/nextImg';
import {StyledShareMenu} from '../../local-seo-scan/local-seo-detail-v2/styled';
import {notification as notificationV2} from '@/utils/notification';
// import {REPORT_BUILDER_API} from '@/api/report-builder';
// import {LargeBadge} from '@/components/common-components/components/badge';
// import {generatePdfApiError} from '@/utils/api';

export const getDateRangeWithNum = dateRange => {
  switch (dateRange) {
    case 'One month':
      return '1 month';
    case 'Three month':
      return '3 months';
    case 'Six month':
      return '6 months';
    case 'One year':
      return '1 year';
    default:
      return '1 month';
  }
};

const getFrequencyName = frequency => {
  switch (frequency) {
    case 7:
      return 'Weekly';
    case 30:
      return 'Monthly';
    case 90:
      return 'Quarterly';
    default:
      return 'Weekly';
  }
};

const dateRangeObj = {
  last_1_month: 'One month',
  last_3_months: 'Three month',
  last_6_months: 'Six month',
  last_year: 'One year',
};


export const FullReportHeader = observer(({dataLoder, reff, loader, dateRange, setIsConfig, resetLayout, isConfig, setHandleBack}:any) => {
  const {
    countries: {getCountriesData},
    // settings: {
    //   customer: {
    //     profile: {
    //       isLinkgraph,
    //     },
    //   },
    // },
  } = useStore('');
  const {
    navBar: {setIsDockedSider},
  } = useStore('');
  const {reportBuilder: {emailsSetting, setIsLocalSEOSave, details: {allLoaderings, loadAISummaries, loadingAiSummaryOverview, loadingAiSummary, btnDisabledOnLoading, localSeoLoading, isAllRender, setAllRender, singleProjectData, exportSingleNodeApi, isExporting, isEdited, setIsConfirmModalVisible}}} = useStore('');
  const getReportId = getSingleUrlParam('report_id');
  // const downloadPdfRef = useRef(null);

  useEffect(() => {
    setIsDockedSider(false);
  }, [isConfig]);

  const getPublicHash = getSingleUrlParam('public_hash');
  const router = useRouter();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [copySuccess, setCopySuccess] = useState(false);
  const [iFrameCopySuccess, setIFrameCopySuccess] = useState(false);
  const [download, setDownload] = useState(false);

  const url = `https://www.google.com/s2/favicons?sz=64&domain_url=${singleProjectData?.domain}`;
  const dateProject = singleProjectData?.dateRangeEnd ? `${moment(singleProjectData?.dateRangeStart).format('ll')} - ${moment(singleProjectData?.dateRangeEnd).format('ll')}` : dateRangeObj[`${singleProjectData?.dateRange}`];

  // const currentDateTime = moment().format('YYYY-MM-DD_HH-mm-ss');
  // const filename = `${singleProjectData?.domain}_${currentDateTime}.pdf`;

  // const handleClickGeneratepdf = async event => {
  //   event.preventDefault();
  //   setDownload(true);
  //   try {
  //     const response = await REPORT_BUILDER_API.generatePdf({
  //       url: singleProjectData?.shareUrl,
  //       elementId: 'capture-pdf',
  //       notionId: !!singleProjectData?.layout?.find(i => i?.name === 'Orders & Tasks') && !!singleProjectData?.notionPageId?.length && singleProjectData?.notionPageId !== 'None' ? 'notion-iframe-loaded' : null,
  //       localSeoId: singleProjectData?.reportsData?.localSeo?.localSeoIds?.length ? 'local-seo-map' : null,
  //       notionScrollId: 'notion-iframe',
  //     });
  //     downloadPdfRef.current.href = `data:application/pdf;base64,${response.base64}`;
  //     downloadPdfRef.current.click();
  //     notification.success('', 'The PDF file has been downloaded to your Downloads folder successfully.');
  //   } catch (error) {
  //     const errorMessage = generatePdfApiError(error);
  //     notification.error('', errorMessage);
  //   } finally {
  //     setDownload(false);
  //   }
  // };

  const handleClickOnExport = async ()=> {
    setDownload(true);
    const node = reff?.current;
    const buttons = node.querySelectorAll('.hideInPdf');
    buttons.forEach(button => button.style.display = 'none');
    const seoIcons = node.querySelectorAll('.rb-seo-icon');
    seoIcons.forEach(seoIcon => seoIcon.style.marginTop = 0);
    exportSingleNodeApi(node, {country: singleProjectData?.location, domain: singleProjectData?.domain, date: dateRange}, true);
    buttons.forEach(button => button.style.display = '');
    seoIcons.forEach(seoIcon => seoIcon.style.marginTop = '5px');
    setDownload(false);
  };


  const findCountryNameByCode = (countryCode, preciseLocation) => {
    try {
      const country = getCountriesData.find(country => country.code.toLowerCase() == countryCode.toLowerCase());
      if (country) return country?.name;
      else return preciseLocation;
    } catch (error) {
      return preciseLocation;
    }
  };

  const handelBack = ()=> {
    if (isEdited) {
      setHandleBack(true);
      setIsConfirmModalVisible(true);
    } else {
      setIsConfig(false);
      router?.push('/report-builder/projects-list');
    }
  };

  const onVisibleChange = (visible:any) => {
    if (!visible) {
      setTimeout(() => {
        setCopySuccess(false);
      }, 300);
    }
  };

  const generateAISummary = async () => {
    try {
      await loadAISummaries(getReportId);
      notificationV2.success('Success', 'AI Summary Generated successfully');
    } catch (error) {
      return Promise.reject(error);
    }
  };

  const shareUrl = () => {
    navigator.clipboard.writeText(isBulkReportPublicPage() ? location.href : singleProjectData?.shareUrl);
    setCopySuccess(true);
    setIsLocalSEOSave(true);
  };

  const dropdownMenu = (
    <StyledShareMenu>
      <Menu.Item style={{whiteSpace: 'nowrap'}} onClick={shareUrl}>Share URL</Menu.Item>
      <Menu.Item
        style={{whiteSpace: 'nowrap'}}
        onClick={() => {
          setIsLocalSEOSave(true);
          const iFrameSrc = removeSpaces(isBulkReportPublicPage() ? location.href : singleProjectData?.shareUrl);
          navigator.clipboard.writeText(
            `<iframe src="${iFrameSrc}"
            style="width: 100%; height: 800px"></iframe>`);
          setIFrameCopySuccess(true);
          setTimeout(() => {
            setCopySuccess(false);
            setIFrameCopySuccess(false);
          }, 1000);
        }}>Get iFrame Code</Menu.Item>
    </StyledShareMenu>
  );

  return (<>
    <BlackHeader isConfig={isConfig} className='bg-main-color'>
      {!getPublicHash && <BackToReport onClick={handelBack}><FontAwesomeIcon icon={faArrowLeft} cursor='pointer'/>&nbsp;&nbsp;&nbsp; Back to Reports List</BackToReport>}
      <HeaderWrapper>
        {dataLoder ? <RingLoaderV2 width='30px'/> : <ImageWrapper> <NextImg src={url} alt='siteImage' height={30} width={30} /></ImageWrapper>}
        <HeaderBtnWrapper>
          {dataLoder ? <div style={{marginLeft: '10px'}}>
            <SkeletonHorizontalLoaderGray height={15} width={150}/>
            <SkeletonHorizontalLoaderGray height={15} width={200}/>
          </div> : <div><h2>{singleProjectData?.domain}</h2>
            <FlexWrapper>
              <p>{findCountryNameByCode(singleProjectData?.location, '') || 'Worldwide'}</p>
              {singleProjectData?.location ? <div>{countryFlag(singleProjectData?.location, '20px')}</div> : <GlobeWrapper/>}
              <div style={{display: 'flex', alignItems: 'center'}}>
                <div style={{marginBottom: '5px'}}>.</div>&nbsp;&nbsp;
                <div>{dateProject?.split('-').length > 1 ? dateProject : `Last ${getDateRangeWithNum(dateProject || '1 year')}`}</div>
                {emailsSetting?.emailFreqDays && emailsSetting?.emailRecipients?.length ? <>&nbsp;&nbsp;<div style={{marginBottom: '5px'}}>.</div>&nbsp;&nbsp;<div>Scheduled Emails:</div>
                  {emailsSetting?.emailSelectedDay && <EmailSpan>On&nbsp;({getFrequencyName(emailsSetting?.emailFreqDays)})</EmailSpan>}</>:''}</div>
            </FlexWrapper>
          </div>}
          {isConfig ? <div>
            <Button onClick={()=> {
              if (isEdited) {
                setIsConfirmModalVisible(true);
              } else {
                setIsConfig(false);
              }
              isAllRender?.length == 0 && setAllRender(['empty']);
            }}>Exit edit mode</Button>
            <Button disabled={btnDisabledOnLoading} onClick={()=> resetLayout(true)}>Reset layout</Button>
          </div> : !getPublicHash ? <div>
            {singleProjectData?.isAiSummaryEnabled ? <Button onClick={generateAISummary} disabled={loadingAiSummary || loadingAiSummaryOverview} > <FontAwesomeIcon spin={loadingAiSummary || loadingAiSummaryOverview} style={{marginRight: '10px'}} color='white' icon={faRotate} /> Generate AI Summary</Button> : <></>}
            <Button disabled={loader} onClick={()=> {
              setIsConfig(!isConfig);
              setAllRender([]);
            }
            }><FontAwesomeIcon color='white' icon={faGear} />Configure Report</Button>
            <Button onClick={handleClickOnExport} disabled={allLoaderings || download || dataLoder || (singleProjectData?.reportsData?.localSeo?.localSeoIds?.length && localSeoLoading)}
              loading={isExporting || dataLoder || allLoaderings || (singleProjectData?.reportsData?.localSeo?.localSeoIds?.length && localSeoLoading)} ><FontAwesomeIcon color='white' icon={faDownload} /> Download</Button>

            {/* {isLinkgraph ? <Button
              onClick={handleClickGeneratepdf}
              loading={download} style={{position: 'relative'}}><LargeBadge alpha style={{position: 'absolute', top: '-19px', right: '0px'}}/><FontAwesomeIcon color='white' icon={faDownload} /> Download</Button>:
              <Button onClick={handleClickOnExport} disabled={allLoaderings || download || dataLoder || (singleProjectData?.reportsData?.localSeo?.localSeoIds?.length && localSeoLoading)}
                loading={isExporting || dataLoder || allLoaderings || (singleProjectData?.reportsData?.localSeo?.localSeoIds?.length && localSeoLoading)} ><FontAwesomeIcon color='white' icon={faDownload} /> Download</Button>
            } */}
            {/* <a ref={downloadPdfRef} href='' download={filename}></a> */}

            <Dropdown overlay={dropdownMenu} trigger={['click']} placement='bottom' disabled={dataLoder || localSeoLoading}>
              <Tooltip
                title={<>
                  {copySuccess && <span><FontAwesomeIcon icon={faCheck} style={{color: '#2AC155'}} />{` Copied to clipboard`}</span>}
                  {iFrameCopySuccess && <span><FontAwesomeIcon icon={faCheck} style={{color: '#2AC155'}} />{` iFrame copied to clipboard`}</span>}
                </>}
                placement='bottom'
                visible={iFrameCopySuccess || copySuccess}
                onVisibleChange={visible => onVisibleChange(visible)}>
                <Button
                  disabled={dataLoder || (singleProjectData?.reportsData?.localSeo?.localSeoIds?.length && localSeoLoading)}
                  loading={dataLoder || (singleProjectData?.reportsData?.localSeo?.localSeoIds?.length && localSeoLoading)}>
                  <FontAwesomeIcon color='white' icon={faLink} />Share
                </Button>
              </Tooltip>
            </Dropdown>
          </div> : <div>
            <Button onClick={async () => {
              await setDownload(true);
              await handleClickOnExport();
            }} disabled={allLoaderings || download || dataLoder || (singleProjectData?.reportsData?.localSeo?.localSeoIds?.length && localSeoLoading)}
            loading={isExporting || dataLoder || allLoaderings || (singleProjectData?.reportsData?.localSeo?.localSeoIds?.length && localSeoLoading)} ><FontAwesomeIcon color='white' icon={faDownload} /> Download</Button>
          </div>}
        </HeaderBtnWrapper>
      </HeaderWrapper>
    </BlackHeader>
    <div id='seoAPSection'></div>

  </>
  );
});

const BackToReport = styled.div`
color: #a3a4a4;
margin-bottom: 14px;
cursor: pointer;
width: fit-content;
`;

const HeaderBtnWrapper = styled.div`
justify-content: space-between;
    width: 100%;
    display: flex;
    align-items: center;
    .ant-btn[disabled]:active {
      background-color: transparent;
      color: white !important;
    }
`;

const GlobeWrapper = styled(Globe)`
height: 14px;
width: 14px;
margin-top: 2px;
color: #fff;
`;

const EmailSpan = styled.span`
  color: #34AEF3;
  margin-left: 3px;
`;


const BlackHeader = styled.div<{isConfig?: boolean}>`
align-items: end;
  justify-content: space-between;
  width: ${p => p?.isConfig ? '1100px' : '1233px'};
  margin: 0 auto 240px;
  transition: margin .4s ease 0s;
  padding: 51px 0 0 0;

  ${p => p?.isConfig && '@media (min-width: 1780px) and (max-width: 1920px) { margin-right: 120px !important; } @media (min-width: 1635px) and (max-width: 1780px) { margin-right: 20px !important; } @media (min-width: 1445px) and (max-width: 1635px) { margin-right: 23px !important; }'}
  ${p => p?.isConfig && '@media (min-width: 1340px) and (max-width: 1445px) { margin-left: 314px !important; } @media (min-width: 1285px) and (max-width: 1370px) { margin-left: 310px !important; }'}
  ${p => p?.isConfig && '@media (max-width: 1280px) { margin-right: 5px !important; } @media (max-width: 1030px) { margin-right: 5px !important; }'}

  .btnWrapper{
    
  }
  button{
    margin-right: 10px;
    background-color: #4E5156 !important;
    border: none;
    color: white !important;
    font-size: 12px;
    border-radius: 8px;
    svg{
      margin-right: 10px;
    }
    &:hover{
      background-color: #4E5156;
    color: white !important;
    }
    &:focus{
      background-color: #4E5156;
    color: white !important;
    }
    &:active{
      background-color: #4E5156;
    color: white !important;
    }
  }
`;

const ImageWrapper = styled.div`
height: 41px;
width: 43px;
background: white;
align-items: center;
display: flex;
justify-content: center;
border-radius: 8px;
`;

const HeaderWrapper = styled.div`
display: flex;
margin-top: 10px;
align-items: center;
.imgUrl{

}
img{
  height: 30px;
  border-radius: 5px;
}
p{
  color: white;
  font-size: 12px;
  margin: 0;
  span{
    color: #34AEF3;
  }
}
h2{
  height: 24px;
  font-weight: 600;
  margin-left: 16px;
    color: white;
}
`;

const FlexWrapper = styled.div<{align?: string; justifyContent?: string; gap?: string}>`
  display: flex;
  align-items: ${p=> p?.align};
  justify-content: ${p=> p?.justifyContent};
  gap: ${p=> p?.gap ? p?.gap : '10px'};
  margin-left: 16px;
  align-items: center;
  color: #e8e8e8;
  p{
    font-size: 14px !important
  }

`;
